import { kebabCase, map } from 'lodash/fp';

import { LocalizedCurrencyValue, LocalizedMarkdown, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { Body, Highlight, NestedCard, Stack, Title, Typography } from '@optimus-web/core';
import { InfoBox } from '../InfoBox';

const mapCompetitors = (price: $TSFixMe) =>
    map((name: string) => (
        <Stack spacing="100" distribution="space-between" key={name}>
            <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                {name}
            </Typography>
            <Typography
                textStyle="bodyMediumStrong"
                variant="secondary"
                data-test-id={`rate-compare-prices-values-${kebabCase(name)}`}
                as="div"
            >
                {price}
            </Typography>
        </Stack>
    ));

export const rateCompareFactory =
    ({ Price = LocalizedCurrencyValue } = {}) =>
    ({ competitors, competitorsPrice, description, opened, lowestRoomPrice, toggleOpened, ...other }: $TSFixMe) => (
        <InfoBox
            opened={opened}
            toggleOpened={toggleOpened}
            data-test-id="rate-compare"
            accessibleText={
                opened === true ? (
                    <LocalizedText textKey={TextKey.HideRateComparison} />
                ) : (
                    <LocalizedText textKey={TextKey.SeeRateComparison} />
                )
            }
            {...other}
            role="complementary"
        >
            <Stack spacing="200" vertical>
                <Title level={3}>
                    <LocalizedText textKey={TextKey.BookOnlineGetMore} />
                </Title>
                {description != null && description !== '' ? (
                    <NestedCard variant="highlighted">
                        <Highlight size="small">
                            <LocalizedText textKey={TextKey.BookOnlineBonuses} />
                        </Highlight>
                        <Body size="medium" overflowWrap="break-word">
                            {/* @ts-expect-error */}
                            <LocalizedMarkdown property={description} />
                        </Body>
                    </NestedCard>
                ) : null}
                <div>
                    <Typography textStyle="bodySmall" variant="secondary" as="div">
                        <LocalizedText textKey={TextKey.OurPrice} />
                    </Typography>
                    <Highlight size="medium">
                        <Price value={lowestRoomPrice} data-test-id="rate-compare-our-price-value" />
                    </Highlight>
                </div>
                <div>
                    <Highlight size="small">
                        <LocalizedText textKey={TextKey.ComparePrices} />
                    </Highlight>
                    {mapCompetitors(<Price value={competitorsPrice} />)(competitors)}
                </div>
            </Stack>
        </InfoBox>
    );

export const RateCompare = rateCompareFactory();
